import { createSlice, isAnyOf } from '@reduxjs/toolkit';
import {
    fetchAllTeams,
    fetchTeams,
    fetchCreateTeam,
    fetchUpdateTeam,
    fetchDeleteTeam,
    fetchTeam,
    fetchTeamEmployees,
    excludeEmployee,
    updateEmployee,
    fetchNotAttachedEmployee,
    attachEmployee,
} from '../thunks/teamThunks.js';

const initialState = {
    loading: false,
    fullList: [],
    error: '',
    teams: {
        list: [],
        maxPageNumber: 0,
    },
    team: {},
    users: {
        list: [],
        maxPageNumber: 0,
    },
    loadingEmployees: false,
    nonAttachedEmployee: [],
};

const teamsSlice = createSlice({
    name: 'teams',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllTeams.fulfilled, (state, action) => {
                state.fullList = action.payload;
                state.loading = false;
            })
            .addCase(fetchTeams.fulfilled, (state, action) => {
                state.teams = action.payload;
                state.loading = false;
            })
            .addCase(fetchTeam.fulfilled, (state, action) => {
                state.team = action.payload;
                state.loadingEmployees = false;
            })
            .addCase(fetchTeamEmployees.pending, (state) => {
                state.loadingEmployees = true;
            })
            .addCase(fetchTeamEmployees.fulfilled, (state, action) => {
                state.users = action.payload;
                state.loadingEmployees = false;
            })
            .addCase(excludeEmployee.fulfilled, (state, action) => {
                state.users.list = state.users.list.filter(({ UserId }) => UserId !== action.payload);
                state.loadingEmployees = false;
            })
            .addCase(fetchNotAttachedEmployee.fulfilled, (state, action) => {
                state.nonAttachedEmployee = action.payload;
            })
            .addCase(attachEmployee.fulfilled, (state, action) => {
                state.users.list = [...action.payload, ...state.users.list];
            })
            .addCase(updateEmployee.fulfilled, (state, action) => {
                const { weight, employeeId } = action.payload;
                state.users.list = state.users.list.map((u) =>
                    u.UserId === employeeId ? { ...u, weight, isApprover: Boolean(weight) } : u,
                );
            })
            .addCase(fetchCreateTeam.fulfilled, (state, action) => {
                state.teams.list.unshift(action.payload);
                state.loading = false;
            })
            .addCase(fetchUpdateTeam.fulfilled, (state, action) => {
                const { data, id } = action.payload;
                state.teams.list = state.teams.list.map((team) => (team.id === id ? { ...data, id } : team));
                state.loading = false;
            })
            .addCase(fetchDeleteTeam.fulfilled, (state, action) => {
                state.teams.list = state.teams.list.filter(({ id }) => id !== action.payload);
                state.loading = false;
            })
            .addCase(fetchTeamEmployees.rejected, (state) => {
                state.users = { list: [], maxPageNumber: 0 };
                state.loadingEmployees = false;
            })
            .addCase(excludeEmployee.rejected, (state, action) => {
                state.error = action.error || action.error?.message;
                state.loadingEmployees = false;
            })
            .addCase(excludeEmployee.pending, (state) => {
                state.loadingEmployees = true;
            })
            .addMatcher(isAnyOf(fetchAllTeams.pending, fetchTeams.pending), (state) => {
                state.loading = true;
            })
            .addMatcher(isAnyOf(fetchAllTeams.rejected, fetchTeams.rejected), (state, action) => {
                state.loading = false;
                state.error = action.error || action.error?.message;
            })
            .addMatcher(isAnyOf(fetchTeam.pending, fetchTeam.rejected), (state) => {
                state.team = {};
            })
            .addDefaultCase((state) => state);
    },
});

export default teamsSlice.reducer;
